/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_CreatorInputs */

const en_plan_creator = /** @type {(inputs: Plan_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creator Plan`)
};

const id_plan_creator = /** @type {(inputs: Plan_CreatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket Kreator`)
};

/** @type {(inputs: Plan_CreatorInputs) => LocalizedString} */
const es_plan_creator = en_plan_creator;

/** @type {(inputs: Plan_CreatorInputs) => LocalizedString} */
const fr_plan_creator = en_plan_creator;

/** @type {(inputs: Plan_CreatorInputs) => LocalizedString} */
const de_plan_creator = en_plan_creator;

/** @type {(inputs: Plan_CreatorInputs) => LocalizedString} */
const ja_plan_creator = en_plan_creator;

/** @type {(inputs: Plan_CreatorInputs) => LocalizedString} */
const zh_plan_creator = en_plan_creator;

/** @type {(inputs: Plan_CreatorInputs) => LocalizedString} */
const ar_plan_creator = en_plan_creator;

/** @type {(inputs: Plan_CreatorInputs) => LocalizedString} */
const it_plan_creator = en_plan_creator;

/** @type {(inputs: Plan_CreatorInputs) => LocalizedString} */
const ru_plan_creator = en_plan_creator;

/** @type {(inputs: Plan_CreatorInputs) => LocalizedString} */
const pt_plan_creator = en_plan_creator;

/** @type {(inputs: Plan_CreatorInputs) => LocalizedString} */
const ko_plan_creator = en_plan_creator;

/**
* | output |
* | --- |
* | "Creator Plan" |
*
* @param {Plan_CreatorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const plan_creator = /** @type {((inputs?: Plan_CreatorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_CreatorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plan_creator(inputs)
	if (locale === "es") return es_plan_creator(inputs)
	if (locale === "fr") return fr_plan_creator(inputs)
	if (locale === "de") return de_plan_creator(inputs)
	if (locale === "ja") return ja_plan_creator(inputs)
	if (locale === "zh") return zh_plan_creator(inputs)
	if (locale === "ar") return ar_plan_creator(inputs)
	if (locale === "id") return id_plan_creator(inputs)
	if (locale === "it") return it_plan_creator(inputs)
	if (locale === "ru") return ru_plan_creator(inputs)
	if (locale === "pt") return pt_plan_creator(inputs)
	return ko_plan_creator(inputs)
});